import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 1, 2026">
      <p className="text-slate-600 leading-relaxed text-[15px]">
        These Terms of Service ("Terms") govern your access to and use of the <strong>ReachMeNow</strong> contact-sharing
        service, website, QR tags, and related products (collectively, the "Service") provided by ReachMeNow ("we", "us", or "our").
        By using the Service, you agree to these Terms. If you do not agree, do not use the Service.
      </p>

      <LegalSection heading="1. The Service">
        <p>ReachMeNow lets you share a QR code so that others can contact you privately, without revealing your phone number or email address. Messages are delivered to your dashboard, where you can reply in real time.</p>
      </LegalSection>

      <LegalSection heading="2. Eligibility & Accounts">
        <ul className="list-disc pl-5 space-y-1">
          <li>You must be at least 19 years old to buy from or create an account on the Service (or the minimum age required in your jurisdiction, if higher).</li>
          <li>You are responsible for the information you provide and for activity that occurs under your account.</li>
          <li>You agree to provide accurate information and to keep it up to date.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Acceptable Use">
        <p>You agree not to use the Service to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Send spam, harassment, threats, or unlawful, harmful, or misleading content.</li>
          <li>Violate the privacy or rights of others, or impersonate any person or entity.</li>
          <li>Attempt to gain unauthorized access to the Service, other accounts, or our systems.</li>
          <li>Interfere with or disrupt the integrity or performance of the Service.</li>
        </ul>
        <p>We may suspend or terminate accounts that violate these Terms.</p>
      </LegalSection>

      <LegalSection heading="4. Messages & Content">
        <p>You are solely responsible for the content of messages you send and receive. ReachMeNow does not endorse and is not responsible for user-generated content. We may remove content or restrict access where we believe these Terms have been violated.</p>
      </LegalSection>

      <LegalSection heading="5. Privacy">
        <p>Your use of the Service is also governed by our <a className="text-brand-blue hover:underline" href="/privacy">Privacy Policy</a>, which describes how we collect and use your information.</p>
      </LegalSection>

      <LegalSection heading="6. Intellectual Property">
        <p>The Service, including its software, design, logos, and content, is owned by ReachMeNow and protected by intellectual property laws. You may not copy, modify, or distribute any part of the Service without our permission.</p>
      </LegalSection>

      <LegalSection heading="7. Crowdfunding & Pre-Orders">
        <p>Any campaign, pledge, perk, or pre-order offered through third-party platforms (such as Indiegogo) is subject to that platform's terms and to any additional terms we provide. Timelines and product features may change during development.</p>
      </LegalSection>

      <LegalSection heading="8. Disclaimers">
        <p>The Service is provided "as is" and "as available" without warranties of any kind, whether express or implied. We do not warrant that the Service will be uninterrupted, error-free, or secure.</p>
      </LegalSection>

      <LegalSection heading="9. Limitation of Liability">
        <p>To the maximum extent permitted by law, ReachMeNow will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, arising from your use of the Service.</p>
      </LegalSection>

      <LegalSection heading="10. Termination">
        <p>You may stop using the Service at any time. We may suspend or terminate your access if you violate these Terms or if we discontinue the Service.</p>
      </LegalSection>

      <LegalSection heading="11. Changes to These Terms">
        <p>We may update these Terms from time to time. We will post the updated version with a new "Last updated" date. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.</p>
      </LegalSection>

      <LegalSection heading="12. Contact Us">
        <p>Questions about these Terms? Contact ReachMeNow at <a className="text-brand-blue hover:underline" href="mailto:support@reachmenow.ca">support@reachmenow.ca</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
